import { myIcons } from "@/utils/icons";

interface TitlePropsI {
    icon: string;
    title: string;
    type: string;
}
export const Title = ({ icon, title, type }: TitlePropsI) => {
    return (
        <div style={{ display: 'flex', gap: '10px', backgroundColor: '#2196f34a', borderBottom: '2px solid #9e9e9e', borderRadius: '8px 8px 0px 0px', padding: '5px', color: 'var(--color-text)' }} >
            <img
                style={{ width: '40px' }}
                src={myIcons.projects[icon as keyof typeof myIcons.projects]} />
            <div>
                <p style={{ fontWeight: 'bold' }} >{title}</p>
                <p>{type}</p>
            </div>
        </div>
    );
}